module.exports = __webpack_public_path__ + "static/img/FASTPAY.52b96eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/FASTPAY.png
// module id = LHz5
// module chunks = 1